<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>تعیین رمز ورود</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                id="tac"
                label="رمز موقت"
                name="tac"
                prepend-icon="fa-sms"
                :append-icon="showPassword ? 'fa-eye' : 'fa-eye-slash'"
                @click:append="showPassword = !showPassword"
                :type="showPassword ? 'text' : 'password'"
                v-model="tac"
                :rules="tacRules"
                clearable
                required
              />

              <v-text-field
                id="new-password"
                label="رمز ورود"
                name="new-password"
                prepend-icon="fa-lock"
                :append-icon="showPassword ? 'fa-eye' : 'fa-eye-slash'"
                @click:append="showPassword = !showPassword"
                :type="showPassword ? 'text' : 'password'"
                v-model="newPassword"
                :rules="passwordRules"
                clearable
                required
              />

              <v-text-field
                id="confirm-password"
                label="تائید رمز ورود"
                name="confirm-password"
                prepend-icon="fa-check-double"
                :append-icon="showPassword ? 'fa-eye' : 'fa-eye-slash'"
                @click:append="showPassword = !showPassword"
                :type="showPassword ? 'text' : 'password'"
                v-model="confirmPassword"
                :rules="passwordRules"
                clearable
                required
              />
            </v-form>
          </v-card-text>
          <v-card-text>
            خوش آمدید، این اولین ورود شما به سامانه است. یک رمز موقت به
            09131970628 ارسال شده است. با استفاده از آن یک رمز ورود برای خود
            ایجاد کنید.
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col>
                <v-btn color="primary" :to="{ name: 'Dashboard' }">
                  <v-icon class="ml-1">far fa-save</v-icon>
                  ذخیره
                </v-btn>
              </v-col>
              <v-col class="text-sm-left">
                <v-btn :to="{ name: 'Login' }">
                  <v-icon class="ml-1">fa-sign-out-alt</v-icon>خروج
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Login",
  data: () => ({
    valid: false,
    tac: "",
    newPassword: "",
    confirmPassword: "",
    showSuccessMessage: false,
    showPassword: false,
    passwordRules: [
      v => !!v || "ورود رمز ورود الزامی است",
      v => (!!v && v.length >= 6) || "حداقل طول رمز ورود 6 کاراکتر است",
      v => (!!v && v.length <= 30) || "حداکثر طول رمز ورود 30 کاراکتر است"
    ],
    tacRules: [
      v => !!v || "ورود رمز موقت الزامی است",
      v => (!!v && v.length === 6) || "حداقل طول رمز موقت 6 کاراکتر است"
    ]
  })
};
</script>
